import React from 'react';
import { compose } from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';

const styles = {
  button: {
    margin: '5px 5px'
  }
};

const enhance = compose();

const button = enhance(({ classes, onClickAction, disabled = false }) => {
  return (
    <Button
      variant="contained"
      color="primary"
      onClick={onClickAction}
      className={classes.button}
      disabled={disabled}
    >
      表示順指定
    </Button>
  );
});

export default withRouter(withStyles(styles)(button));
